import { addMessages } from '@hana/i18n';

// Chuỗi danh sách Job. Mã nghiệp vụ, tên riêng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'jobList.filter': 'Lọc',
  'jobList.saveView': 'Lưu view',
  'jobList.columns': 'Hiển thị',
  'jobList.newJob': 'Tạo job',
  'jobList.urgent': 'Gấp',
  'jobList.assign': 'Giao việc',
  'jobList.retry': 'Thử lại',
  'jobList.noWrite': 'Chưa mở ghi ở bản này',
  'jobList.swMore': 'Thao tác khác',
  'jobList.swAdd': 'Thêm',
  'jobList.mine': 'Của tôi',
  'jobList.viewSort': 'Xem · sắp xếp ▾',
  'jobList.swRemind': 'Nhắc khách',
  'jobList.swStatus': 'Trạng thái',
});
addMessages('en', {
  'jobList.filter': 'Filter',
  'jobList.saveView': 'Save view',
  'jobList.columns': 'Columns',
  'jobList.newJob': 'New job',
  'jobList.urgent': 'Urgent',
  'jobList.assign': 'Assign',
  'jobList.retry': 'Retry',
  'jobList.noWrite': 'Writing is not enabled in this version',
  'jobList.swMore': 'More actions',
  'jobList.swAdd': 'More',
  'jobList.mine': 'Mine',
  'jobList.viewSort': 'View · sort ▾',
  'jobList.swRemind': 'Remind customer',
  'jobList.swStatus': 'Status',
});

addMessages('vi', { 'jobList.overdue': 'Việc quá hạn' });
addMessages('en', { 'jobList.overdue': 'Overdue tasks' });

addMessages('vi', {
  'jobList.openVessel': 'Mở hồ sơ tàu',
  'jobList.actions': 'Thao tác',
  'jobList.moreTabs': 'Thêm tab',
  'jobList.searchScope': 'Phạm vi tìm',
  'jobList.searchJob': 'Tìm job',
  'jobList.searchPaste': 'Tìm hoặc dán nhiều mã,',
  'jobList.noRange': 'Chọn khoảng thời gian chưa mở ở bản này',
  'jobList.noAdv': 'Bộ lọc nâng cao chưa mở ở bản này',
  'jobList.viewKind': 'Kiểu xem',
  'jobList.noView': 'Kiểu xem này chưa mở ở bản này',
  'jobList.noCols': 'Chọn cột hiển thị chưa mở ở bản này',
  'jobList.urgentTip': 'Cut-off dưới 48h, quá hạn đóng hoặc task quá hạn',
  'jobList.cards': 'Thẻ',
  'jobList.searchPh': 'Tìm job, khách, booking, tàu…',
  'jobList.listLabel': 'Danh sách Job',
  'jobList.selectAll': 'Chọn tất cả',
  'jobList.prevPage': 'Trang trước',
  'jobList.createJob': 'Tạo job',
  'jobList.thisMonth': 'Tháng này',
});
addMessages('en', {
  'jobList.openVessel': 'Open vessel profile',
  'jobList.actions': 'Actions',
  'jobList.moreTabs': 'More tabs',
  'jobList.searchScope': 'Search scope',
  'jobList.searchJob': 'Search jobs',
  'jobList.searchPaste': 'Search or paste multiple codes,',
  'jobList.noRange': 'Date range is not enabled in this version',
  'jobList.noAdv': 'Advanced filters are not enabled in this version',
  'jobList.viewKind': 'View',
  'jobList.noView': 'This view is not enabled in this version',
  'jobList.noCols': 'Column picker is not enabled in this version',
  'jobList.urgentTip': 'Cut-off under 48h, past close, or overdue tasks',
  'jobList.cards': 'Cards',
  'jobList.searchPh': 'Search job, customer, booking, vessel…',
  'jobList.listLabel': 'Job list',
  'jobList.selectAll': 'Select all',
  'jobList.prevPage': 'Previous page',
  'jobList.createJob': 'Create job',
  'jobList.thisMonth': 'This month',
});

addMessages('vi', {
  'jobList.a11y1': 'Bảng',
});
addMessages('en', {
  'jobList.a11y1': 'Table',
});
